<template>
    <div>
    <div v-if="!this.emission" ref="rootElement">   
        <div 
            class="container-fluid mr-0 ml-0 p-0 input d-flex flex-column" 
            :class="{ 'w-100': isMobile, 'flex-column align-items-start gap-2': this.isMobile, 'mt-3': !needDecision, 'gap-2': needDecision && !isMobile, 'gap-4': !needDecision }"
        >
            <div class="d-flex w-100 gap-2" :class="{ 'flex-column': this.isMobile || (rootWidth <= 768 && !needDecision), 'flex-row': needDecision && !isMobile, 'flex-row justify-content-between': rootWidth > 768 }">
                <div class="p-0 mt-0 d-flex align-items-center justify-content-between">
                    <label class="lh20 neue-roman text-nowrap" :class="{ 'primary-grey fsp16 col-6': rootWidth > 768, 'fsp14 lh20 col-12': (rootWidth <= 768 && !needDecision) || isMobile }">
                        {{ $t('components.service.Comiss.1') }}
                    </label>
                </div>
                <div class="input-wrapper loader-r-cc p-0 mt-0" :class="{ 'col-12': rootWidth <= 768 && !needDecision, 'flex-grow-1': needDecision && !isMobile, 'col-6': rootWidth > 768 || (needDecision && !isMobile) }">
                    <loading :active="this.loader"
                        :is-full-page="false"
                        :height='20'
                        :width='50'
                        :loader='"dots"'
                        :color='"#008D3E"'
                        :opacity='0'
                        />
                    <InputSimple :class="{ 'border-orange': needDecision, 'w328': needDecision && !isMobile }" :disabled='true' id='commis_total' :dataValue="this.total && this.total + ' ' + this.curr"/>
                    <!-- <div v-if="this.$store.state.resize.w > 575 && this.curr" :id="'comiss-2-'+this.id" class="input-wrapper p-0 mt-0 pl8">
                        {{this.curr}}
                    </div> -->
                </div>
            </div>
            <div class="d-flex w-100 gap-2" :class="{ 'flex-column': this.isMobile || (rootWidth <= 768 && !needDecision), 'justify-content-between': rootWidth > 768 && !needDecision, 'justify-content-end': needDecision && !isMobile, 'flex-row': rootWidth > 768 && !needDecision, 'flex-row': rootWidth > 768 }">
                <div class="input-wrapper p-0" :class="{ 'col-12': rootWidth <= 768 && !needDecision, }">
                    <label class="input-label" :class="{ 'col-12': rootWidth > 768 && !needDecision, 'fsp16 primary-grey': rootWidth > 768, 'fsp14 lh20': (rootWidth <= 768 && !needDecision) || isMobile }">{{ $t('components.service.Comiss.2') }}</label>
                </div>
                <div v-if="this.button" class="col-6 input-wrapper p-0 mt-0">
                    <Button class='col-12' :id="'comiss-3-'+this.id" :name="$t('components.service.Comiss.3')" type='btn-outline-warning' v-on:click='this.info = !this.info'/>
                </div>
                <div v-else class="input-wrapper loader-r-cc p-0 mt-0" :class="{ 'col-12': rootWidth <= 768 && !needDecision, 'col-6': rootWidth > 768 }">
                    <loading :active="this.loader"
                        :is-full-page="false"
                        :height='20'
                        :width='50'
                        :loader='"dots"'
                        :color='"#008D3E"'
                        :opacity='0'
                        />
                    <InputSimple :class="{ 'border-orange': needDecision, 'w328': needDecision && !isMobile }" :disabled='true' id='commis_f' :dataValue='this.comiss'/>
                </div>
            </div>
        </div>
        <div v-if="this.enrollment" class="row container-fluid mr-0 ml-0 mt-4 p-0 g-3 align-items-center input">
            <div class="col-sm-6 p-0 mt-0" :class="{ 'primary-grey': !this.isMobile }">
                <label class="input-label" :class="{ 'fsp16': !this.isMobile, 'fsp14': this.isMobile }">{{ $t('components.service.Comiss.4') }}</label>
            </div>
            <div class="col-sm-6 input-wrapper loader-r-cc p-0 mt-0" >
                <loading :active="this.loader"
                    :is-full-page="false"
                    :height='20'
                    :width='50'
                    :loader='"dots"'
                    :color='"#008D3E"'
                    :opacity='0'
                    />
                <InputSimple :class="{ 'border-orange': needDecision }" :disabled='true' id='commis_total' :dataValue='this.to_enrollment'/>
            </div>
            <!-- <div class="col-sm-1 input-wrapper p-0 mt-0 pl8" :id="'comiss-4-'+this.id">
                {{this.curr_to}}
            </div> -->
            <div class="col-sm-3 input-wrapper p-0 pl-2 text-end mt-0">

            </div>
        </div>
        <div v-if="this.info" class="row container-fluid mr-0 ml-0 mt-3 p-0 g-3 align-items-center">
            <div class="col-sm-3 p-0 mt-0">

            </div>
            <div class="table-responsive col-sm-9 p-0 m-0">
                <table class="table table-borderless neue-roman m-0">
                    <tbody class=''>
                        <tr v-for="(row, index) in this.infoData" :key="index">
                            <td class="p-0 d-flex flex-row align-items-center justify-content-start">
                                <span :id="'comiss-i-1-'+this.id+'-'+index">{{`${row.type_name}: ${row.value} ${row.curr_text}`}}</span>
                                <span :id="'comiss-i-1-'+this.id+'-'+index" v-if="row.comment" class="fst-italic ml-1 fs_09">({{row.comment}})</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div v-if="this.emission">
        <div class="d-flex justify-content-between align-items-center mb16">
            <h4 class='fsp20 lh28 neue mb-0'>{{ this.$t('components.service.modal.Emission.11') }}</h4>
            <div v-if="this.button" class="neue color-menu text-decoration-underline pointer" @click='this.info = !this.info'>{{ this.$t('components.service.modal.Emission.30') }}</div>
        </div> 
        <div 
            class="container-fluid mr-0 ml-0 mt-3 p-0 input flex-nowrap d-flex justify-content-between align-items-center gap-3" 
            :class="{ 'flex-column align-items-start gap-2': this.isMobile }"
        >
            <div class="p-0 mt-0 d-flex flex-row align-items-center justify-content-between" :class="{ 'w-136': !this.isMobile }">
                <label class="fsp14 lh20 neue-roman" >
                    {{ $t('components.service.Comiss.1') }}
                </label>
            </div>
            <div class="input-wrapper loader-r-cc p-0 mt-0 flex-grow-1" :class="{ 'w-100': this.isMobile }">
                <loading :active="this.loader"
                    :is-full-page="false"
                    :height='20'
                    :width='50'
                    :loader='"dots"'
                    :color='"#008D3E"'
                    :opacity='0'
                />
                <InputSimple :disabled='true' id='commis_total' :dataValue="this.total && this.total + ' ' + this.curr"/>
            </div>
        </div>
        <div v-if="this.enrollment" class="row container-fluid mr-0 ml-0 mt-3 p-0 g-3 align-items-center input">
            <div class="col-sm-3 p-0 mt-0">
                <label class="input-label">{{ $t('components.service.Comiss.4') }}</label>
            </div>
            <div class="col-sm-3 input-wrapper loader-r-cc p-0 mt-0">
                <loading :active="this.loader"
                    :is-full-page="false"
                    :height='20'
                    :width='50'
                    :loader='"dots"'
                    :color='"#008D3E"'
                    :opacity='0'
                    />
                <InputSimple :disabled='true' id='commis_total' :dataValue='this.to_enrollment'/>
            </div>
            <div class="col-sm-1 input-wrapper p-0 pl-1 mt-0" :id="'comiss-4-'+this.id">
                {{this.curr_to}}
            </div>
            <div class="col-sm-3 input-wrapper p-0 pl-2 text-end mt-0">

            </div>
        </div>
        <div v-if="this.info" class="row container-fluid mr-0 ml-0 mt-3 p-0 g-3 align-items-center">
            <div class="col-sm-3 p-0 mt-0">

            </div>
            <div class="table-responsive col-sm-9 p-0 m-0">
                <table class="table table-borderless neue-roman m-0">
                    <tbody class=''>
                        <tr v-for="(row, index) in this.infoData" :key="index">
                            <td class="p-0 d-flex flex-row align-items-center justify-content-start">
                                <span :id="'comiss-i-1-'+this.id+'-'+index">{{`${row.type_name}: ${row.value} ${row.curr_text}`}}</span>
                                <span :id="'comiss-i-1-'+this.id+'-'+index" v-if="row.comment" class="fst-italic ml-1 fs_09">({{row.comment}})</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import InputSimple from '@/components/service/InputSimple';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Button from '@/components/service/Button';

export default {
    components: {
        InputSimple,
        Loading,
        Button
    },
    data() {
        return {
            timeout: false,
            comiss: '',
            total: '',
            to_enrollment: '',
            loader: false, 
            button: false,
            info: false,
            rootWidth: 0,
            resizeObserver: null,
        }
    },
    props: { 
        sum: {
            type: [Number, String, Boolean]
        },
        id: {
            default: 'def_comiss',
            type: [String, Boolean]
        },
        curr: [String],
        curr_to: [String],
        precision: [String],
        precision_from: [String, Boolean],
        enrollment: [Boolean],
        cmd_name: [String, Boolean],
        params: [Object, Boolean],
        update: [Boolean],  //Рудимент  НЕ ИСПОЛЬЗОВАТЬ!!!!
        onMountStart: [Boolean],
        off_watcher: [Boolean],
        emission: [Boolean],
        needDecision: [Boolean],
    },
    mounted() {
        if (this.onMountStart && this.sum) {
            this.getCommiss(this.sum);
        }
        this.$nextTick(() => {
            if (this.$refs.rootElement) {
                this.getRootWidth();
                this.resizeObserver = new ResizeObserver(() => {
                    this.getRootWidth();
                });
                this.resizeObserver.observe(this.$refs.rootElement);
            }
        });
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    watch: {
        sum(newS, oldS) {
            if (this.off_watcher) {
                return;
            }
            this.getCommiss(newS)
        },
        update(NewU, oldU) {
            if (NewU == true && this.sum) {
                this.getCommiss(this.sum);
            }
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        getRootWidth() {
            if (this.$refs.rootElement) {
                this.rootWidth = this.$refs.rootElement.offsetWidth;
            }
        },
        outputValue(val) {
            if (val) {
                // this.total = String((Number(this.sum) + Number(this.comiss)).toFixed(Number(this.precision))).replace(/0*$/,"");
                // if (this.total[this.total.length - 1] == '.') {
                //     this.total += '00';
                // }
                return val.change.toString().replace(/^-/, '');
            } else {
                return '';
            } 
        },
        getRes(arr) { 
            let res = 0
            arr.forEach(e => {
                res += Number(e.value);
            });
            return String(res);
        },
        getCommiss(newS) {
            if (this.timeout) {
                window.clearTimeout(this.timeout);
            }
            let paramsCopy = { ...this.params };
            if(paramsCopy.protect == '1' && !paramsCopy.protect_code) {
                delete paramsCopy.protect;
                delete paramsCopy.protect_day;
            }
            this.timeout = setTimeout(() => {
            if(!this.emission) {
                this.$emit('updateParentState', false)
            }
            this.$emit('onSuccess', false);
                if (typeof newS !== 'undefined' && newS[newS.length - 1] != '.' && newS !== '') {
                    this.button = false;
                    this.infoData = [];
                    this.info = false;
                    this.loader = true;
                    this.comiss = false;
                    this.total = false;
                    this.to_enrollment = false;
                    this.axios.post('GetComiss', {no_loader: true, data: {
                        cmd_params: paramsCopy,
                        cmd_name: this.cmd_name,
                    }}).then(res => {
                            this.loader = false;
                            if (res.data.body.result != 0) {
                                this.$emit('updateParentState', res.data.body.result_text)
                            } else {
                                if (res.data.body.tables[0].colvalues.length > 0) {
                                    this.button = true;
                                    this.info = true
                                    this.infoData = res.data.body.tables[0].colvalues;
                                }
                                this.comiss = this.getRes(res.data.body.table.colvalues);
                                if (res.data.body.tables[1].colvalues.length == 1) {
                                    this.total = this.outputValue(res.data.body.tables[1].colvalues[0]);
                                    this.to_enrollment = true;
                                } else if (res.data.body.tables[1].colvalues.length > 1) {
                                    if (Number(res.data.body.tables[1].colvalues[0].change) < 0) {
                                        this.total = this.outputValue(res.data.body.tables[1].colvalues[0]);
                                        this.to_enrollment = this.outputValue(res.data.body.tables[1].colvalues[1]);
                                    } else {
                                        this.total = this.outputValue(res.data.body.tables[1].colvalues[1]);
                                        this.to_enrollment = this.outputValue(res.data.body.tables[1].colvalues[0]);
                                    }
                                }
                                if (!this.total || !this.to_enrollment) {
                                    this.$emit('updateParentState', this.$t('components.service.Comiss.5'));
                                    return;
                                }
                                this.$emit('updateParentState', false)
                                this.$emit('onSuccess', true)
                                this.$emit('updateComiss', this.comiss)
                            } 
                    })
                } else {
                    this.comiss = '';
                    this.total = this.outputValue(false);
                    this.$emit('updateParentState', false)
                }
            }, 1000);
        },
        getTotal() {
            return this.total;
        }
    },

}
</script>

<style lang="scss" scoped>
.input {
    font-family: 'HelveticaNeue roman';
    &-wrapper {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
    }
}
.mt-1 {
    margin: 0 !important;
}
.require {
    color: red;
}

.vld-overlay {
    justify-content: flex-start;
    height: 20px;
    position: absolute;
    top: 23%;
    left: 10%;
    bottom: 28%;
}
.loader-r-cc {
    min-height: 20px;
    position: relative;
}
.w-136 {
    width: 136px !important;
    flex-shrink: 0;
}
.border-orange {
    border-color: $dark-orange;
    background-color: inherit !important;
    color: black !important;
    
    :deep(input:disabled) {
        background-color: inherit !important;
        color: black !important;
    }
}

.w328 {
    width: 328px !important;
}
</style>